export const GA_ID = 'G-1PJHKMMMSH';

export function pageview(path: string) {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', 'page_view', { page_path: path });
  }
}


